import { createClient } from '@wallyhealth/web-core'
import config from '../../config'

const client = createClient({ baseUrl: config.MESSAGING_KAPI_URL })

export const unsubscribe = ({ token, campaignId }) => {
  const body = { token, campaignId }

  return client.post('/public/unsubscribe', body)
    .then(response => response.data)
}
